import React from 'react';
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';

function EtapasProducaoGrid({ arrayEtapas, clickDelete, userPermissions }) {
    // Função de formatação de data e hora
    const formatDate = (dateString) => {
        if (!dateString) return '-';
        return new Date(dateString).toLocaleString('pt-BR', {
            day: '2-digit', month: '2-digit', year: 'numeric',
            hour: '2-digit', minute: '2-digit'
        });
    };

    if (!arrayEtapas || arrayEtapas.length === 0) {
        return (
            <div className="text-center p-5 text-muted">
                <i className="fas fa-hammer fa-3x mb-3 text-secondary"></i>
                <h5>Nenhuma etapa encontrada</h5>
                <p>Não há etapas cadastradas ou que correspondam à sua pesquisa.</p>
            </div>
        );
    }

    // Ordena as etapas pela sequência antes de renderizar (se já não vier ordenado do back)
    const etapasOrdenadas = [...arrayEtapas].sort((a, b) => a.sequencia - b.sequencia);

    return (
        <div className="table-responsive">
            <table className="table table-custom table-hover align-middle mb-0">
                <thead>
                    <tr>
                        <th scope="col" className="text-center" style={{ width: '100px' }}>Ações</th>
                        <th scope="col" className="text-start" style={{ width: '100px' }}>Sequência</th>
                        <th scope="col" className="text-start">Descrição</th>
                        <th scope="col" className="text-start">Data Cadastro</th>
                        <th scope="col" className="text-start">Usuário Cadastro</th>
                        <th scope="col" className="text-start">Data Alt.</th>
                        <th scope="col" className="text-start">Usuário Alt.</th>
                    </tr>
                </thead>
                <tbody>
                    {etapasOrdenadas.map(etapa => (
                        <tr key={etapa.id}>
                            <td className="text-center" data-label="Ações">
                                <div className="actions-cell">
                                    <Link
                                        to={`/app/editar-etapa/${etapa.id}`}
                                        className="btn-action-sm btn-edit"
                                        title="Editar"
                                        onClick={(e) => {
                                            // Validation for Edit
                                            if (userPermissions && userPermissions['editar_etapas_producao'] === false) {
                                                e.preventDefault();
                                                Swal.fire({
                                                    icon: 'error',
                                                    title: 'Acesso Negado',
                                                    text: 'Este usuário não possui permissão de edição. Por favor, contate o administrador.',
                                                    confirmButtonColor: '#2185c6'
                                                });
                                            }
                                        }}
                                    >
                                        <i className="fas fa-edit"></i>
                                    </Link>
                                    <button onClick={() => clickDelete(etapa.id)} className="btn-action-sm btn-delete" title="Excluir">
                                        <i className="fas fa-trash"></i>
                                    </button>
                                </div>
                            </td>
                            <td className="text-start" data-label="Sequência">{etapa.sequencia}</td>
                            <td data-label="Descrição">{etapa.descricao}</td>
                            <td className="small text-muted" data-label="Data Cadastro">{formatDate(etapa.data_cadastro)}</td>
                            <td className="small" data-label="Usuário Cadastro">{etapa.usuario_cadastro || '-'}</td>
                            <td className="small text-muted" data-label="Data Alt.">{formatDate(etapa.data_ultima_alteracao)}</td>
                            <td className="small" data-label="Usuário Alt.">{etapa.usuario_ultima_alteracao || '-'}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}

export default EtapasProducaoGrid;